import { render } from "./WorkFormComponent.vue?vue&type=template&id=76cb71ce&scoped=true"
import script from "./WorkFormComponent.vue?vue&type=script&lang=js"
export * from "./WorkFormComponent.vue?vue&type=script&lang=js"

import "./WorkFormComponent.vue?vue&type=style&index=0&id=76cb71ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76cb71ce"]])

export default __exports__